import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Roles } from "../services/roles.service";
import { FinancialDocumentsRouterComponent } from "./components/financial-documents-router.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: "", component: FinancialDocumentsRouterComponent,
        data: { isPublic: true },
      },
      {
        path: "financial-documents-v1",
        loadChildren: () => import("../financial-documents/financial-documents.module").then(m => m.FinancialDocumentsModule),
        data: {
          routeName: "S4-Financial_documents",
          authorized: [Roles.Application, Roles.ConstruagilApplication],
        },
      },
      {
        path: "financial-documents-v1/:sourceApp",
        loadChildren: () => import("../financial-documents/financial-documents.module").then(m => m.FinancialDocumentsModule),
        data: {
          routeName: "S4-Financial_documents-Construagil",
          authorized: [Roles.ConstruagilApplication],
        },
      },
      {
        path: "financial-documents-v2",
        loadChildren: () => import("../financial-documents-v2/financial-documents-v2.module").then(m => m.FinancialDocumentsModuleV2),
        data: {
          routeName: "S4-Financial_documents-v2",
          authorized: [Roles.Application, Roles.ConstruagilApplication],
        },
      },
      {
        path: "financial-documents-v2/:sourceApp",
        loadChildren: () => import("../financial-documents-v2/financial-documents-v2.module").then(m => m.FinancialDocumentsModuleV2),
        data: {
          routeName: "S4-Financial_documents-v2-Construagil",
          authorized: [Roles.ConstruagilApplication],
        },
      },
    ]),
  ],
  declarations: [FinancialDocumentsRouterComponent],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FinancialDocumentsRouterModule {
  constructor() { }
}
